namespace TabAurous.OMS {
    export namespace FixedRateForFGService {
        export const baseUrl = 'OMS/FixedRateForFG';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<FixedRateMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "OMS/FixedRateForFG/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>FixedRateForFGService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
